<template>
  <div>
    <el-form class="search-form" inline :model="searchForm">
      <el-form-item>
        <el-radio-group v-model="searchForm.enabled" @change="getRows()">
          <el-radio-button :label="1">已启用</el-radio-button>
          <el-radio-button :label="0">已禁用</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.keyword" placeholder="用户名/姓名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <org-cascader v-model="searchForm.orgCodes" placeholder="组织机构" clearable></org-cascader>
      </el-form-item>
      <el-form-item>
        <role-select v-model="searchForm.roleCode" placeholder="角色" clearable></role-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="searching" @click="getRows()">查询</el-button>
        <el-button icon="el-icon-plus" @click="add({code:''})">新建</el-button>
      </el-form-item>
      <el-form-item>
        <router-link to="/management/orgMembers">
          <el-button>组织机构管理</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <jbf-table v-loading="searching" :columns="columns" :data="rows" @sort-change="handleSortChange"
               @selection-change="selectionChangeHandler"
               :page-size.sync="pageSize"
               :total="total"
               :current-page.sync="pageNumber"
               @size-change="handleSizeChange"
               @page-change="handleCurrentChange">
      <template slot="roleCode" slot-scope="data">
        {{ data.row.roleName }}
      </template>
      <template slot="empId" slot-scope="data">
        <el-button type="text" @click="checkUserHandler(data.row)">{{ data.row.empId }}</el-button>
      </template>
      <template slot="saleCode" slot-scope="data">
        {{ data.row.saleCode }}
      </template>
      <template slot="operation" slot-scope="data">
        <el-button v-if="$auth('user_update')" type="text" @click="edit(data)">修改</el-button>
        <el-button v-if="$auth('user_update')" class="btn-danger" v-show="data.row.enabled" type="text"
                   @click="updateEnabled(data.row, 0)">
          禁用
        </el-button>
        <el-button v-if="$auth('user_update')" class="btn-success" v-show="!data.row.enabled" type="text"
                   @click="updateEnabled(data.row, 1)">
          启用
        </el-button>
        <el-button v-if="$auth('reset_password')" class="btn-warning" type="text" @click="resetPassword(data.row)">
          重置密码
        </el-button>
      </template>
      <div v-if="$auth('user_update')" style="display: inline-block;padding-top: 10px" slot="batchOptions">
        <el-button v-show="showSaveBtn" :loading="saving" @click="batchEnable(1)">
          启用
        </el-button>
        <el-button v-show="showSaveBtn" :loading="saving" @click="batchEnable(0)">
          禁用
        </el-button>
      </div>
    </jbf-table>

    <el-dialog :title="editTitle" :visible.sync="editVisible">
      <el-form ref="editForm" label-width="120px" :model="editForm" :rules="editRules">
        <el-form-item label="用户名" prop="username">
          <el-input type="text" maxlength="20" minlength="4" show-word-limit v-model="editForm.username"
                    :readonly="editTitle==='修改'"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input type="text" maxlength="20" show-word-limit v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="组织机构" prop="orgCodes">
          <org-cascader v-model="editForm.orgCodes" filterable></org-cascader>
        </el-form-item>
        <el-form-item label="角色" prop="roleCodes">
          <role-cascader v-model="editForm.roleCodes" filterable></role-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-folder" @click="save(true)" :loading="editSaving">保存</el-button>
          <!--          <el-button icon="el-icon-folder" @click="save(false)">保存并继续添加</el-button>-->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import BasePage from "@/components/BasePage";
import {changeEnabled, resetPassword, userInsert, userList, userUpdate} from "@/api/remote";
import RoleSelect from "@/components/form/RoleSelect";
import OrgCascader from "@/components/form/OrgCascader";
import {regex, stringSplit} from "@/assets/utils";
import RoleCascader from "@/components/form/RoleCascader";

export default {
  name: "account",
  components: {RoleCascader, OrgCascader, RoleSelect},
  mixins: [BasePage],
  data() {
    return {
      searching: false,
      searchForm: {
        keyword: null,
        orgCodes: [],
        roleCode: null,
        enabled: 1,
      },
      rows: [],
      columns: [
        {type: 'selection', width: '50px'},
        {label: '用户名', prop: 'username', show: true, sortable: 'custom'},
        {label: '姓名', prop: 'name', show: true},
        {label: '邮箱', prop: 'email', show: true, sortable: 'custom'},
        {label: '电话', prop: 'phone', show: true, sortable: 'custom'},
        {label: '组织机构', prop: 'orgNames', show: true},
        {label: '角色', prop: 'roleCode', show: true},
        {label: '注册时间', prop: 'created', show: false},
        {prop: 'operation', width: '165px', align: 'center'},
      ],
      editVisible: false,
      editSaving: false,
      editTitle: '新增',
      editItem: null,
      editForm: {
        username: null,
        name: null,
        email: null,
        phone: null,
        enabled: 1,
        orgCode: null,
        orgCodes: [],
        roleCode: null,
        roleCodes: [],
      },
      editRules: {
        username: [
          {required: true, trigger: 'change', message: '请输入用户名'}
        ],
        name: [
          {required: true, trigger: 'change', message: '请输入姓名'}
        ],
        phone: [
          {required: true, pattern: regex.phone, message: '请填写正确的号码', trigger: 'blur'},
        ],
        orgCodes: [
          {required: true, trigger: 'change', message: '请选择组织机构'}
        ],
        email: [
          {required: true, trigger: 'change', type: 'email', message: '请输入正确的邮箱'}
        ],
        roleCodes: [
          {required: true, trigger: 'change', message: '请选择角色'}
        ],
      },
      selection: [],
      saving: false,
      showSaveBtn: false,
    }
  },
  computed: {
    userOrgCode() {
      return this.$store.state.userInfo.orgCode;
    },
    userRoleCode() {
      return this.$store.state.userInfo.roleCode;
    }
  },
  methods: {
    getRows(pageNumber, pageSize) {
      this.searching = true;
      this.pageNumber = pageNumber || 1;
      this.pageSize = pageSize || this.pageSize;
      let form = {
        ...this.searchForm,
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        orderBy: this.orderBy,
      };
      if (form.orgCodes.length > 0) {
        form.orgCode = form.orgCodes[form.orgCodes.length - 1]
      }
      delete form.orgCodes;
      userList(form).then(res => {
        this.total = res.total;
        this.rows = res.data;
        this.searching = false;
      }, () => this.searching = false)
    },
    selectionChangeHandler(selection) {
      this.selection = selection;
      this.showSaveBtn = selection.length >= 1;
    },
    add() {
      this.editForm = {};
      this.editTitle = '新增';
      this.editVisible = true;
    },
    edit({row}) {
      let item = {...row};
      item.orgCodes = stringSplit(item.orgCodes);
      let i = item.orgCodes.findIndex(code => code === this.userOrgCode);
      if (i >= 0) {
        item.orgCodes = item.orgCodes.slice(i, item.orgCodes.length);
      }
      item.roleCodes = stringSplit(item.roleCodes);
      i = item.roleCodes.findIndex(code => code === this.userRoleCode);
      item.roleCodes = item.roleCodes.slice(i, item.roleCodes.length);

      this.editForm = item;
      this.editTitle = '修改';
      this.editVisible = true;
    },
    encodeForm(data) {
      let form = {...data};
      let orgCodes = form.orgCodes;
      if (orgCodes && orgCodes.length > 0) {
        form.orgCode = orgCodes[orgCodes.length - 1]
      }
      delete form.orgCodes;

      let roleCodes = form.roleCodes;
      if (roleCodes && roleCodes.length > 0) {
        form.roleCode = roleCodes[roleCodes.length - 1]
      }
      delete form.roleCodes;
      return form;
    },
    save(close) {
      this.$refs.editForm.validate().then(() => {
        let form = this.encodeForm(this.editForm);
        if (this.editTitle === '修改') {
          this.editSaving = true;
          userUpdate(form).then(res => {
            this.$message.success('修改成功');
            this.getRows(this.pageNumber, this.pageSize);
            this.editSaving = false;
            this.editVisible = false;
          }, () => this.editSaving = false)
        } else {
          this.editSaving = true;
          form.enabled = true;
          userInsert(form).then(res => {
            this.rows.unshift(form);
            this.total++;
            this.$message.success('创建成功');
            this.editSaving = false;
            this.editForm = {};
            // 是否关闭弹出框
            this.editVisible = !close;
          }, () => this.editSaving = false)
        }
      });
    },
    updateEnabled(row, enabled) {
      this.$confirm(`确定${enabled ? '启用' : '禁用'}${row.username}?`).then(() => {
        changeEnabled({username: row.username, enabled: enabled}).then(res => {
          this.$message.success('操作成功');
          row.enabled = enabled;
          // this.getRows(this.pageNumber, this.pageSize);
        })
      })
    },
    batchEnable(enabled) {
      this.saving = true;
      let length = this.selection.length;
      let i = 0;
      this.selection.forEach(row => {
        changeEnabled({username: row.username, enabled: enabled}).then(res => {
          row.enabled = enabled;
          if (++i >= length) {
            this.saving = false
          }
        })
      })
    },
    resetPassword(row) {
      this.$confirm(`${row.username}，确定重置密码?`).then(() => {
        resetPassword({username: row.username}).then(res => {
          this.$message.success('密码修改成功，新密码:' + res.data);
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
